<template>
  <div>
    <van-cell-group v-for="(item,index) in searchTypeList" :key="index">
      <van-cell :title="item.name" is-link to="/material/add-type" value="新建类别"/>
      <van-cell-group class="mt10" style="padding:0 1rem">
        <van-cell :title="subItem.name" is-link to="/material/edit-type" value="编辑类别" v-for="(subItem,i) in item.child" :key="i"/>
      </van-cell-group>
    </van-cell-group>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        searchTypeList: [{
          name: '资产名称设置',
          child: []
        }, {
          name: '材料名称设置',
          child: []
        }, {
          name: '生产的商品名称设置',
          child: [{
            name: '茶杯'
          }, {
            name: '保温杯'
          }]
        }],
      }
    }
  }
</script>

